export default __webpack_public_path__ + "static/media/unlink.b8761030.svg";